import React, { useEffect, useRef, useState } from 'react';
import './AutoFitText.scss'; // global import

const AutoFitText = ({
    children,
    maxFontSize = 28,
    minFontSize = 8,
    lineHeightRatio = 1.2,
    fontFamily = 'inherit',
    textAlign = 'center',
    padding = 0,
}) => {
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [fontSize, setFontSize] = useState(maxFontSize);

    const resizeText = () => {
        const container = containerRef.current;
        const textEl = textRef.current;
        if (!container || !textEl) return;

        let size = maxFontSize;

        const style = window.getComputedStyle(container);
        const paddingY =
            parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        const paddingX =
            parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        const maxHeight = container.clientHeight - paddingY;
        const maxWidth = container.clientWidth - paddingX;

        textEl.style.fontSize = `${size}px`;
        textEl.style.lineHeight = `${lineHeightRatio}`;

        while (
            (textEl.scrollHeight > maxHeight ||
                textEl.scrollWidth > maxWidth) &&
            size > minFontSize
        ) {
            size -= 1;
            textEl.style.fontSize = `${size}px`;
        }

        setFontSize(size);
    };

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            requestAnimationFrame(resizeText);
        });

        if (containerRef.current) observer.observe(containerRef.current);
        resizeText();

        return () => observer.disconnect();
    }, [children]);

    return (
        <div
            ref={containerRef}
            className="auto-fit-container"
            style={{
                '--auto-fit-padding':
                    typeof padding === 'number' ? `${padding}px` : padding,
                '--auto-fit-font-family': fontFamily,
                '--auto-fit-text-align': textAlign,
                '--auto-fit-line-height': lineHeightRatio,
            }}
        >
            <div ref={textRef} className="auto-fit-text" style={{ fontSize }}>
                {children}
            </div>
        </div>
    );
};

export default AutoFitText;
